// extracted by mini-css-extract-plugin
export default {"conteudo":"home_conteudo__wE0OB","descricao":"home_descricao__dCb6V","obs":"home_obs__VgVDC","borda-botao":"home_borda-botao__F6XB7"};